/* tslint:disable */
/* eslint-disable */
import { PhaseDisplayModel as AceXFoundPortalCoreCaqModelsPhaseDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/phase-display-model';
import { GlobalEnumsAceAnzeigestatusportal as AceXFoundPortalCoreEntitiesGlobalEnumsAceAnzeigestatusportal } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-anzeigestatusportal';
import { GlobalEnumsAceJaNein as AceXFoundPortalCoreEntitiesGlobalEnumsAceJaNein } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-ja-nein';
import { GlobalEnumsAcePortalstatus as AceXFoundPortalCoreEntitiesGlobalEnumsAcePortalstatus } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-portalstatus';
import { GlobalEnumsAceXfoundportalobjekt as AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt';
import { AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode as AceXFoundPortalCoreEntitiesAceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode } from '../../../../../../ace/xFound/Portal/Core/Entities/ace-ausschreibung-ace-ausschreibung-enums-ace-ausschreibung-statuscode';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { PhaseDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup } from '@/api/model-index';

export interface IAnfrageListDisplayModel {
  anzahlUngelesenerNachrichten?: number;
  anzeigestatus?: AceXFoundPortalCoreEntitiesGlobalEnumsAceAnzeigestatusportal;
  ausschreibungDatumBis?: null | string;
  ausschreibungName?: null | string;
  ausschreibungsStatus?: AceXFoundPortalCoreEntitiesAceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode;
  berichtInBearbeitung?: boolean;
  berichtVorhanden?: boolean;
  foerderprogrammName?: null | string;
  freigegebenZurUeberarbeitung?: null | string;
  freigegebenbis?: null | string;
  hasAntragsdatenblatt?: boolean;
  id: string;
  mittelabrufSperren?: AceXFoundPortalCoreEntitiesGlobalEnumsAceJaNein;
  name?: null | string;
  nummer?: null | string;
  objektTyp?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
  phase?: AceXFoundPortalCoreCaqModelsPhaseDisplayModel;
  portalStatus?: AceXFoundPortalCoreEntitiesGlobalEnumsAcePortalstatus;
  status?: null | number;
}
export class AnfrageListDisplayModel extends BaseModel implements IAnfrageListDisplayModel {
  anzahlUngelesenerNachrichten?: number;
  anzeigestatus?: AceXFoundPortalCoreEntitiesGlobalEnumsAceAnzeigestatusportal;
  ausschreibungDatumBis?: null | string;
  ausschreibungName?: null | string;
  ausschreibungsStatus?: AceXFoundPortalCoreEntitiesAceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode;
  berichtInBearbeitung?: boolean;
  berichtVorhanden?: boolean;
  foerderprogrammName?: null | string;
  freigegebenZurUeberarbeitung?: null | string;
  freigegebenbis?: null | string;
  hasAntragsdatenblatt?: boolean;
  id: string;
  mittelabrufSperren?: AceXFoundPortalCoreEntitiesGlobalEnumsAceJaNein;
  name?: null | string;
  nummer?: null | string;
  objektTyp?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
  phase?: AceXFoundPortalCoreCaqModelsPhaseDisplayModel;
  portalStatus?: AceXFoundPortalCoreEntitiesGlobalEnumsAcePortalstatus;
  status?: null | number;
}
class BaseAnfrageListDisplayModelFormGroup extends FormGroup {
  private static _instance: AnfrageListDisplayModelFormGroup;
  
  public static get Instance(): AnfrageListDisplayModelFormGroup {
    this._instance = new AnfrageListDisplayModelFormGroup({
      anzahlUngelesenerNachrichten: new FormControl(null),
      anzeigestatus: new FormControl(null),
      ausschreibungDatumBis: new FormControl(null),
      ausschreibungName: new FormControl(null),
      ausschreibungsStatus: new FormControl(null),
      berichtInBearbeitung: new FormControl(null),
      berichtVorhanden: new FormControl(null),
      foerderprogrammName: new FormControl(null),
      freigegebenZurUeberarbeitung: new FormControl(null),
      freigegebenbis: new FormControl(null),
      hasAntragsdatenblatt: new FormControl(null),
      id: new FormControl(null, [Validators.required]),
      mittelabrufSperren: new FormControl(null),
      name: new FormControl(null),
      nummer: new FormControl(null),
      objektTyp: new FormControl(null),
      phase: AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup.Instance,
      portalStatus: new FormControl(null),
      status: new FormControl(null),
    });

    return this._instance;
  }
}


export class AnfrageListDisplayModelFormGroup extends BaseAnfrageListDisplayModelFormGroup {
  public get AnzahlUngelesenerNachrichten(): FormControl {
    return this.controls["anzahlUngelesenerNachrichten"] as FormControl;
  }
  public get Anzeigestatus(): FormControl {
    return this.controls["anzeigestatus"] as FormControl;
  }
  public get AusschreibungDatumBis(): FormControl {
    return this.controls["ausschreibungDatumBis"] as FormControl;
  }
  public get AusschreibungName(): FormControl {
    return this.controls["ausschreibungName"] as FormControl;
  }
  public get AusschreibungsStatus(): FormControl {
    return this.controls["ausschreibungsStatus"] as FormControl;
  }
  public get BerichtInBearbeitung(): FormControl {
    return this.controls["berichtInBearbeitung"] as FormControl;
  }
  public get BerichtVorhanden(): FormControl {
    return this.controls["berichtVorhanden"] as FormControl;
  }
  public get FoerderprogrammName(): FormControl {
    return this.controls["foerderprogrammName"] as FormControl;
  }
  public get FreigegebenZurUeberarbeitung(): FormControl {
    return this.controls["freigegebenZurUeberarbeitung"] as FormControl;
  }
  public get Freigegebenbis(): FormControl {
    return this.controls["freigegebenbis"] as FormControl;
  }
  public get HasAntragsdatenblatt(): FormControl {
    return this.controls["hasAntragsdatenblatt"] as FormControl;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get MittelabrufSperren(): FormControl {
    return this.controls["mittelabrufSperren"] as FormControl;
  }
  public get Name(): FormControl {
    return this.controls["name"] as FormControl;
  }
  public get Nummer(): FormControl {
    return this.controls["nummer"] as FormControl;
  }
  public get ObjektTyp(): FormControl {
    return this.controls["objektTyp"] as FormControl;
  }
  public get Phase(): AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup {
    return this.controls["phase"] as AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup;
  }
  public get PortalStatus(): FormControl {
    return this.controls["portalStatus"] as FormControl;
  }
  public get Status(): FormControl {
    return this.controls["status"] as FormControl;
  }
  

}

export module AnfrageListDisplayModelForm
  {
    export class FormFields
    {
      static _anzahlUngelesenerNachrichten: string = "anzahlUngelesenerNachrichten";
      static _anzeigestatus: string = "anzeigestatus";
      static _ausschreibungDatumBis: string = "ausschreibungDatumBis";
      static _ausschreibungName: string = "ausschreibungName";
      static _ausschreibungsStatus: string = "ausschreibungsStatus";
      static _berichtInBearbeitung: string = "berichtInBearbeitung";
      static _berichtVorhanden: string = "berichtVorhanden";
      static _foerderprogrammName: string = "foerderprogrammName";
      static _freigegebenZurUeberarbeitung: string = "freigegebenZurUeberarbeitung";
      static _freigegebenbis: string = "freigegebenbis";
      static _hasAntragsdatenblatt: string = "hasAntragsdatenblatt";
      static _id: string = "id";
      static _mittelabrufSperren: string = "mittelabrufSperren";
      static _name: string = "name";
      static _nummer: string = "nummer";
      static _objektTyp: string = "objektTyp";
      static _phase: string = "phase";
      static _portalStatus: string = "portalStatus";
      static _status: string = "status";
    }
  }

